import React from "react";

import { HStack, Text } from "@chakra-ui/react";

import InspectorMenu from "@/assets/InspectorMenu";
import InspectorMenuActive from "@/assets/InspectorMenuActive";
import LeftMenuIcon from "@/assets/LeftMenuIcon";
import ShipOwnerMenuActive from "@/assets/ShipOwnerMenuActive";
import ShipOwnerMenu from "@/assets/ShipOwnerMenu";
import InspectorPersonMenu from "@/assets/InspectorPersonMenu";
import InspectorPersonMenuActive from "@/assets/InspectorPersonMenuActive";
import InspectionFeeMenu from "@/assets/InspectionFeeMenu";
import InspectionFeeMenuActive from "@/assets/InspectionFeeMenuActive";
import ManageInvoiceMenu from "@/assets/ManageInvoiceMenu";
import ManageInvoiceMenuActive from "@/assets/ManageInvoiceMenuActive";
import ArrowDown from "@/assets/ArrowDown";
import ArrowRight from "@/assets/ArrowRight";
import DotInactive from "@/assets/DotInactive";
import LeftMenuGreenIcon from "@/assets/LeftMenuGreenIcon";
import UserManagementMenuActive from "@/assets/UserManagementMenuActive";
import UserManagementMenu from "@/assets/UserManagementMenu";
import SettingsMenuActive from "@/assets/SettingsMenuActive";
import SettingsMenu from "@/assets/SettingsMenu";
import NotificationBadge from "../NotificationBadge";
import { COLORS } from "@/common/constants";
import DashboardMenu from "@/assets/DashboardMenu";
import SireReviewMenu from "@/assets/SireReviewMenu";
import InspectionNominationMenu from "@/assets/InspectionNominationMenu";
import InvoiceMenu from "@/assets/InvoiceMenu";
import InspectionStatusMenu from "@/assets/InspectionStatusMenu";
import UploadInspectionResultMenu from "@/assets/UploadInspectionResultMenu";
import InspectionProcessMenu2 from "@/assets/InspectionProcessMenu2";

interface MenuItemProps {
    isActive: boolean;
    label: string;
    activeIcon: JSX.Element;
    inactiveIcon: JSX.Element;
    onClick: () => void;
    totalNew?: number;
}

const MenuItem: React.FC<MenuItemProps> = ({ isActive, label, activeIcon, inactiveIcon, onClick, totalNew }) => (
    <HStack
        height="50px"
        bgColor={isActive ? COLORS.HIGHLIGHT : 'white'}
        borderRightRadius={10}
        onClick={onClick}
        cursor="pointer"
        fontWeight="bold"
    >
        {isActive ? (
            <>
                <LeftMenuIcon />
                {activeIcon}
            </>
        ) : (
            inactiveIcon
        )}
        <Text color={isActive ? '#000' : '#98A2B3'}>{label}</Text>
        {totalNew && <NotificationBadge count={totalNew} />}
    </HStack>
);

const ExpandableMenuItem: React.FC<MenuItemProps & { isExpanded: boolean; toggle: () => void }> = ({
    isActive,
    label,
    activeIcon,
    inactiveIcon,
    isExpanded,
    toggle,
    totalNew
}) => (
    <HStack
        display='flex'
        justifyContent='space-between'
        height='50px'
        cursor='pointer'
        bgColor={isActive ? '#F3F6F9' : 'white'}
        borderRightRadius={10}
        fontWeight='bold'
        onClick={toggle}
    >
        <div style={{ display: 'flex' }}>
            {isActive ? (
                <>
                    <LeftMenuGreenIcon />
                    {activeIcon}
                </>
            ) : (
                inactiveIcon
            )}
            <Text marginLeft={2} marginRight={2} paddingTop={isActive ? 3 : 0} color={isActive ? '#000' : '#98A2B3'}>
                {label}
            </Text>
            <div style={{ marginTop: isActive ? '12px' : '0px' }}>{totalNew && <NotificationBadge count={totalNew} />}</div>
        </div>
        {isExpanded ? <ArrowDown style={{ cursor: 'pointer', marginRight: '10px' }} /> : <ArrowRight style={{ marginRight: '10px', cursor: 'pointer' }} />}
    </HStack>
);

const getActiveIcon = (name: string): JSX.Element | null | undefined => {
    switch (name) {
        case 'dashboard':
            return <DashboardMenu isActive />;
        case 'inspectionstatus':
            return <InspectionStatusMenu isActive />;
        case 'manageinspectingcompany':
            return <InspectorMenuActive />;
        case 'managevessel':
        case 'manageshipoperator':
            return <ShipOwnerMenuActive />;
        case 'manageinspector':
            return <InspectorPersonMenuActive />;
        case 'manageinspectionfee':
            return <InspectionFeeMenuActive />;
        case 'managesirereview':
            return <SireReviewMenu isActive />;
        case 'manageinspectionnomination':
            return <InspectionNominationMenu isActive />;
        case 'manageinspectionprocess':
            return <InspectionProcessMenu2 isActive />;
        case 'inspectionresult':
            return <UploadInspectionResultMenu isActive />;
        case 'manageinvoices':
            return <InvoiceMenu isActive />;
    }
}

const getActiveIconSubMenu = (name: string): JSX.Element | null | undefined => {
    switch (name) {
        case 'manageinvoices':
            return <ManageInvoiceMenuActive style={{ marginLeft: 19, marginTop: '12px' }} />;
        case 'usermanagement':
            return <UserManagementMenuActive style={{ marginLeft: 19, marginTop: '12px' }} />;
        case 'settings':
            return <SettingsMenuActive style={{ marginLeft: 19, marginTop: '14px' }} />;
    }
}

const getInactiveIcon = (name: string): JSX.Element | null | undefined => {
    switch (name) {
        case 'dashboard':
            return <DashboardMenu isActive={false} style={{ marginLeft: 19 }} />;
        case 'inspectionstatus':
            return <InspectionStatusMenu isActive={false} style={{ marginLeft: 19 }} />;
        case 'manageinspectingcompany':
            return <InspectorMenu style={{ marginLeft: 19 }} />;
        case 'managevessel':
        case 'manageshipoperator':
            return <ShipOwnerMenu style={{ marginLeft: 19 }} />;
        case 'manageinspector':
            return <InspectorPersonMenu style={{ marginLeft: 19 }} />;
        case 'manageinspectionfee':
            return <InspectionFeeMenu style={{ marginLeft: 19 }} />;
        case 'managesirereview':
            return <SireReviewMenu isActive={false} style={{ marginLeft: 19 }} />;
        case 'manageinspectionnomination':
            return <InspectionNominationMenu isActive={false} style={{ marginLeft: 19 }} />;
        case 'manageinspectionprocess':
            return <InspectionProcessMenu2 isActive={false} style={{ marginLeft: 19 }} />;
        case 'inspectionresult':
            return <UploadInspectionResultMenu isActive={false} style={{ marginLeft: 19 }} />;
        case 'manageinvoices':
            return <InvoiceMenu isActive={false} style={{ marginLeft: 19 }} />;
    }
}

const getInactiveIconSubMenu = (name: string): JSX.Element | null | undefined => {
    switch (name) {
        case 'manageinvoices':
            return <ManageInvoiceMenu style={{ marginLeft: 19 }} />;
        case 'usermanagement':
            return <UserManagementMenu style={{ marginLeft: 19, marginTop: '2px' }} />;
        case 'settings':
            return <SettingsMenu style={{ marginLeft: 19 }} />;
    }
}

const getTotalNew = (name: string, total: any, role: string, isParent = false) => {
    switch (name) {
        case 'manageinspectingcompany':
            return total?.inspectingCompany;
        case 'manageshipoperator':
            return total?.shipOperator;
        case 'manageinspector':
            return total?.inspector;
        case 'manageinspectionfee':
            return 0
        case 'managesirereview':
            return total?.sireReview;
        case 'manageinspectionnomination':
            if (role === 'inspecting company') {
                return total?.nominationInspector;
            } else if (role === 'ship operator') {
                return total?.nominationShipOperator;
            }

            return 0;
        case 'manageinspectionprocess':
            return total?.inspectionProcess;
        case 'manageinvoices':
            if (isParent && (role === 'super admin' || role === 'admin finance')) {
                return total?.invoiceInspectingCompany + total?.invoiceShipOperatorAdmin;
            } else if (isParent && role === 'inspecting company') {
                return total?.invoiceInspectingCompany;
            } else if (isParent && role === 'ship operator') {
                return total?.invoiceShipOperator;
            }

            return 0;
        case 'inspectingcompany':
            if (isParent && (role === 'super admin' || role === 'admin finance')) {
                return total?.invoiceInspectingCompany;
            } else if (isParent && role === 'inspecting company') {
                return total?.invoiceInspectingCompany;
            }

            return 0;
        case 'shipoperator':
            if (isParent && (role === 'super admin' || role === 'admin finance')) {
                return total?.invoiceShipOperatorAdmin;
            } else if (isParent && role === 'ship operator') {
                return total?.invoiceShipOperator
            }

            return 0;
    }
}

const GenericMenus = ({
    location,
    handleNav,
    handleOpenSubMenuGeneric,
    opened,
    totalNew,
    menus,
    isReviewer,
    role
}: any) => {
    return (
        <>
            {menus?.map((item: any) => {
                if (item?.isParent) {
                    return (
                        <React.Fragment key={item.id}>
                            <ExpandableMenuItem
                                key={item.id}
                                isActive={location.pathname.includes(item.url)}
                                label={item.name}
                                totalNew={getTotalNew(item.key, totalNew, role, item?.isParent)}
                                activeIcon={getActiveIconSubMenu(item.key) || <ManageInvoiceMenuActive style={{ marginLeft: 19, marginTop: '12px' }} />}
                                inactiveIcon={getInactiveIconSubMenu(item.key) || <ManageInvoiceMenu style={{ marginLeft: 19 }} />}
                                onClick={() => handleOpenSubMenuGeneric(item.key)}
                                isExpanded={opened[item.key]}
                                toggle={() => handleOpenSubMenuGeneric(item.key)}
                            />
                            {opened[item.key] && (
                                item?.children?.map((itemChild: any) => {
                                    return (
                                        <React.Fragment key={itemChild.id}>
                                            <HStack marginBottom="4" onClick={() => handleNav(itemChild.url)} cursor='pointer' fontWeight='bold' marginLeft={4}>
                                                <DotInactive style={{ marginLeft: 19 }} />
                                                <Text color={location.pathname.includes(itemChild.url) ? '#000' : '#98A2B3'}>{itemChild.name}</Text>
                                                {getTotalNew(itemChild.key, totalNew, role, item?.isParent) && <NotificationBadge count={getTotalNew(itemChild.key, totalNew, role, item?.isParent)} />}
                                            </HStack>
                                        </React.Fragment>
                                    )
                                })
                            )}
                        </React.Fragment>
                    )
                }

                if (!item?.isParent) {
                    // jika role inspecting & key = managesirereview & isReviewer = false maka dilewat
                    // return (
                    //     <MenuItem
                    //         key={item.id}
                    //         isActive={location.pathname.includes(item.url)}
                    //         label={item.name}
                    //         totalNew={getTotalNew(item.key, totalNew)}
                    //         activeIcon={getActiveIcon(item.key) || <ManageInvoiceMenuActive />}
                    //         inactiveIcon={getInactiveIcon(item.key) || <ManageInvoiceMenu style={{ marginLeft: 19 }} />}
                    //         onClick={() => handleNav(item.url)}
                    //     />
                    // )

                    if (!(role === "inspectingcompany" && item.key === "managesirereview" && !isReviewer)) {
                        return (
                            <MenuItem
                                key={item.id}
                                isActive={location.pathname.includes(item.url)}
                                label={item.name}
                                totalNew={getTotalNew(item.key, totalNew, role)}
                                activeIcon={getActiveIcon(item.key) || <ManageInvoiceMenuActive />}
                                inactiveIcon={getInactiveIcon(item.key) || <ManageInvoiceMenu style={{ marginLeft: 19 }} />}
                                onClick={() => handleNav(item.url)}
                            />
                        );
                    }
                }
            })}
        </>
    );
};

export default GenericMenus;
